module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/002ba0140d2bec1d251f56ae475c7832.png";